import { useEffect } from 'react'

import { EVENT_NAME_KEY_DOWN } from '../constants/event'
import { preventDefault } from '../utils/events'

export function useKeyboardListener({ callback, eventKey }) {
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === eventKey) {
        preventDefault(event)

        callback()
      }
    }

    window.addEventListener(EVENT_NAME_KEY_DOWN, handleKeyDown)

    return function cleanup() {
      window.removeEventListener(EVENT_NAME_KEY_DOWN, handleKeyDown)
    }
  }, [callback, eventKey])
}
